import filter from 'lodash/filter';
import head from 'lodash/head';

export class CallCenterStatisticsService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.callCenterStatisticsResourceUrl = this.apiService.getResourceUrl('menus/GetthereCallCenterStatistics');

		this.callCenterStatisticsResource = this.$resource(this.callCenterStatisticsResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getContentObject(values) {
		let details = filter(values, ['name', 'GetthereCallCenterStatistics']);
		return _getContentData(head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				pdf: value.pdf,
				title: value.title,
				image: value.image,
				description: value.description,
				createdAt: value.created_at
			}));
		}		
	}

	/**
	 * function to get call center statistics content
	 * @return {object} [information related to call center statistics]
	 */
	
	getReportDetails(details) {
		return {
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			details: this._getContentObject(details.data.content)
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/publications-documents-call-center-statistics/publications-documents-call-center-statistics.service.js